module.exports = __webpack_public_path__ + "media/images/payments/payu-b770dcc7727b7ab2e75094f3d7f70c75.svg";